@import "~@uipath/apollo-core/src/scss/base-host.scss";

:host {
  display: block;
  .divider {
    background-color: var(--color-border-de-emp);

    &.horizontal-bar {
      height: 1px;
      margin: $pad-s 0;
      width: calc(100% - (2 * $pad-s));
      background-color: var(--color-border-de-emp);
    }

    &.xs {
      width: calc(100% - (2 * $pad-xs));
      margin-left: $pad-xs;
      margin-right: $pad-xs;
    }
    &.sm {
      width: calc(100% - (2 * $pad-s));
      margin-left: $pad-s;
      margin-right: $pad-s;
    }
    &.md {
      width: calc(100% - (2 * $pad-m));
      margin-left: $pad-m;
      margin-right: $pad-m;
    }
    &.lg {
      width: calc(100% - (2 * $pad-l));
      margin-left: $pad-l;
      margin-right: $pad-l;
    }
    &.xl {
      width: calc(100% - (2 * $pad-xl));
      margin-left: $pad-xl;
      margin-right: $pad-xl;
    }
    &.xxl {
      width: calc(100% - (2 * $pad-xxl));
      margin-left: $pad-xxl;
      margin-right: $pad-xxl;
    }
    &.xxxl {
      width: calc(100% - (2 * $pad-xxxl));
      margin-left: $pad-xxxl;
      margin-right: $pad-xxxl;
    }

    &.ignore-width-margins {
      width: 100%;
    }
    
    &.vertical-bar {
      width: 1px;
      height: 24px;
    }

    &.h-xs {
      margin-top: $pad-xs;
      margin-bottom: $pad-xs;
    }
    &.h-sm {
      margin-top: $pad-s;
      margin-bottom: $pad-s;
    }
    &.h-md {
      margin-top: $pad-m;
      margin-bottom: $pad-m;
    }
    &.h-lg {
      margin-top: $pad-l;
      margin-bottom: $pad-l;
    }
    &.h-xl {
      margin-top: $pad-xl;
      margin-bottom: $pad-xl;
    }
    &.h-xxl {
      margin-top: $pad-xxl;
      margin-bottom: $pad-xxl;
    }
    &.h-xxxl {
      margin-top: $pad-xxxl;
      margin-bottom: $pad-xxxl;
    }
  }
}
